import dayjs from 'dayjs';
import orderby from 'lodash.orderby';
import chunk from 'lodash.chunk';
import api from '../../api/index.js';
import utc from 'dayjs-plugin-utc';


dayjs.extend(utc);

export default {
  namespaced: true,
  state     : {
    day_flag          : true,
    yesterday_flag    : true,
    days_ago_flag     : true,
    push_notifications: [],
    notifications     : [],

  },
  getters: {
    day_flag                       : ({day_flag}) => day_flag,
    push_notifications             : ({push_notifications}) => push_notifications,
    push_notifications_active      : ({push_notifications}) => push_notifications.filter((notification) => notification.new),
    push_notifications_active_count: ({push_notifications}) => push_notifications.filter((notification) => notification.new).length,
    yesterday_flag                 : ({yesterday_flag}) => yesterday_flag,
    days_ago_flag                  : ({days_ago_flag}) => days_ago_flag,
    notifications                  : ({notifications}) => notifications,
    chunks                         : ({notifications}) => {
      const sortered = orderby(notifications, (o) => o.date).reverse();
      return chunk(sortered, 5);
    },
    yesterday: ({notifications}) => {
      const sortered = orderby(notifications, (o) => o.date);
      const date = new Date();
      const yesterday = new dayjs(date.setDate(date.getDate()-1)).format('DD.MM.YYYY');
      let a = sortered.filter((x) =>{
        return (new dayjs(parseInt(x.date)).utc().format('DD.MM.YYYY')) == yesterday;
      });
      return a;
    },
    days_left({notifications}) {
      const sortered = orderby(notifications, (o) => o.date);
      const date = new Date();
      const five_days_left = date.setDate(date.getDate()-5);
      let a = sortered.filter((x)=> {
        return x.date <= five_days_left;
      });
      return a;
    },

  },
  mutations: {
    SET_NOTIFICATIONS(state, value) {
      state.notifications = value;
      state.push_notifications = value;
    },
    SET_READ_MESSAGE(state, value) {
      let index;

      state.notifications.forEach((x, i) => {
        if (x.notification_id == value.notification_id) {
          index = i;
        }
      });

      if (index) {
        state.notifications[index].new = false;
      }
    },
    SET_PUSH_NOTIFICATIONS(state, value) {
      state.push_notifications = value;
    },
    DELETE_READ_NOTE(state, value) {
      state.push_notifications = state.push_notifications.filter((x) => x.notification_id !== value.notification_id);
    },

  },
  actions: {
    async get_notifications({commit}) {
      try {
        const res = await api.notifications.get_notifications();
        res.data.forEach((element) => {
          element.date = element.date * 1000;
        });
        commit('SET_NOTIFICATIONS', res.data);
      } catch (err) {
        console.error(err);
      }
    },
    async check_push_notifications({commit}) {
      try {
        const res = await api.notifications.get_notifications();
        let new_res = res.data.filter((x) => x.new == true);
        if (new_res.length) {
          commit('SET_PUSH_NOTIFICATIONS', new_res);
        }
        return new_res;
      } catch (err) {
        console.error(err);
      }
    },
    async set_read_note({}, id) {
      try {
        await api.notifications.patch_read(id);
      } catch (err) {
        console.error(err);
      }
    },
    async set_read_notes({}, values) {
      try {
        await api.notifications.patch_reads({ids: values});
      } catch (err) {
        console.error(err);
      }
    },
  },
};
